<template>
  <div class="popup-container h-100 w-100 visible-mobile hidden-tablet fixed top-0 right-0 flex flex-column">
    <div class="bestseller-popup align-self-end brdr-rectangle c-bg-white align-items-center flex-row flex">
      <div class="align-self-start fs12 py10 align-left lh15 pl10 pr5">
        <div class="bold popup-text">
          <span v-html="title" />
        </div>
        <div class="regular pt5">
          <span v-html="message" />
        </div>
      </div>
      <div class="align-self-start mr10 mt7">
        <i
          class="icon icon-close regular pointer px2 py2 fs9"
          @click="close"
        />
      </div>
    </div>
    <div
      class="popup background c-bg-black fixed top-0 left-0 h-100 w-100"
      @click="close"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      showBestSellerPopup: state => state.ui.showBestSellerPopup
    }),
    title () {
      return this.$t('Best selling event')
    },
    message () {
      return this.$t('This event is among the top 25% best selling events on our website during the last 7 days.')
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.catchScroll)
  },
  mounted () {
    window.addEventListener('scroll', this.catchScroll, { passive: true })
  },
  methods: {
    close () {
      this.$store.commit('ui/setShowBestSellerPopup', null)
    },
    catchScroll () {
      if (this.showBestSellerPopup) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/grid';

.popup-container {
  z-index: map-get($z-index, modal);
  position: absolute;
  top: 14px;
  left: 0;

  .popup-text {
    opacity: 0.8;
  }

  .bestseller-popup {
    z-index: map-get($z-index, modal);
    margin: 0;
    height: fit-content;
  }

  .popup {
    z-index: map-get($z-index, quantity-popup);
    opacity: 0.1;
  }
}
</style>
